import React, { useCallback } from 'react';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { Country } from '../types';


type CountriesAdminColumnRendererProps = {
  value: Country,
  rowIndex: number,
}

const CountriesAdminColumnRendererFactory = ({
  showModalForEdit,
  showModalForRemove,
}: {
  showModalForEdit: (entity: Country) => void,
  showModalForRemove: (data: { entityToRemove: Country, rowIndex: number }) => void,
}) => {
  const CountriesAdminColumnRenderer = ({
    value: entity,
    rowIndex,
  }: CountriesAdminColumnRendererProps) => {
    const showEditModal = useCallback(() => {
      showModalForEdit(entity);
    }, [entity]);

    const showRemoveModal = useCallback(() => {
      showModalForRemove({ entityToRemove: entity, rowIndex });
    }, [entity, rowIndex]);

    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Country"
          onClick={showEditModal}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>

        <button
          className="cell-icon-button"
          title="Remove Country"
          onClick={showRemoveModal}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  };
  return CountriesAdminColumnRenderer;
};

export default CountriesAdminColumnRendererFactory;
